import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PuiAuthService } from '../../../core/index';

declare var App;

@Component({
  template: '&nbsp;'
})
export class PuiCallbackComponent implements OnInit {

  constructor(private router: Router,
    private authService: PuiAuthService) { }

  ngOnInit() {
    App.startPageLoading({ animate: true });
    this.authService.parseOAuthResult()
      .filter(data => data !== null)
      .subscribe(data => {
        App.stopPageLoading();
        this.router.navigate([this.authService.redirectUrl]);
      }, err => {
        App.stopPageLoading();
        // TODO: exception handling
        console.error(err);
        this.router.navigate(['auth/login']);
      });
  }

}
